<template>
  <div style="font-size:14px" v-if="subjects && proceedings">
    <h5 class="title">
      <span @click="onViewProceeding(proceedings['사전평가 분석회의'], '사전평가 분석회의')"
        :class="isActive('사전평가 분석회의')">
        <mdb-icon  icon="dot-circle" /> 사전평가 분석회의
        <mdb-icon  v-if="proceedings['사전평가 분석회의']" icon="tag" color="danger"/>
      </span>
    </h5>
    <hr>
    <div v-if="subjects.NCS && proceedings.NCS">
      <folder-label label="NCS 교과" :open="true">
        <ul class="list-unstyled">
          <li class="ml-3" v-for="(s, i) in subjects.NCS" :key="i">
            <mdb-icon  icon="chalkboard-teacher" /> {{s.name}}
            <ul class="list-unstyled">
              <li class="ml-3" v-for="(l, i) in s.lectures" :key="i">
                <span @click="onViewProceeding(proceedings.NCS[l.name], s.name, l.name, l.code)"
                  :class="isActive(l.name)">
                  <mdb-icon  icon="chalkboard" /> {{l.name}}
                  <mdb-icon  v-if="proceedings.NCS[l.name]" icon="tag" color="danger"/>
                </span>
              </li>
            </ul>
          </li>
        </ul>
      </folder-label>
    </div>
    <hr>
    <div v-if="subjects.NONNCS && proceedings.NONNCS" >
      <folder-label label="비 NCS 교과" :open="true">
        <ul class="list-unstyled">
          <li class="ml-3" v-for="(s, i) in subjects.NONNCS" :key="i">
            <span @click="onViewProceeding(proceedings.NONNCS[s.name], s.name)"
              :class="isActive(s.name)">
              <mdb-icon  icon="chalkboard-teacher" /> {{s.name}}
              <mdb-icon  v-if="proceedings.NONNCS[s.name]" icon="tag" color="danger"/>
            </span>
          </li>
        </ul>
      </folder-label>
    </div>
    <hr>
    <folder-label label="비정기 회의록" :open="true">
      <ul class="list-unstyled" v-if="proceedings['비정기 회의록']">
        <li class="ml-3" v-for="(s, i) in occasionals" :key="i">
          <span @click="onViewProceeding(proceedings['비정기 회의록'][s], '비정기 회의록', s, s)"
              :class="isActive(s)">
            <mdb-icon  icon="chalkboard-teacher" /> {{s}}
            <mdb-icon  v-if="proceedings['비정기 회의록'][s]" icon="tag" color="danger"/>
          </span>
        </li>
      </ul>
      <div class="text-center" v-if="isStaff">
        <add-btn-sm @click="onAddOccasional">추가</add-btn-sm>
      </div>
    </folder-label>
    <modal-dlg v-if="modal" size="lg" icon="plus" title="비정기 회의록 추가" :show="modal"  @close="onClose">
      <div>
        <mdb-input label="비정기 회의 교과목" v-model="occasionalTitle"/>
      </div>
      <div class="text-center">
        <mdb-btn class="py-2" color="primary" @click="onSaveOccasional">저장</mdb-btn>
        <mdb-btn class="py-2" @click="onClose">닫기</mdb-btn>
      </div>
    </modal-dlg>
  </div>
</template>
<script>
import { mdbIcon } from 'mdbvue';
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import FolderLabel from '@/components/common/FolderLabel.vue';
export default {
  name: 'ProceedingCategory',
  components: { FolderLabel },
  props: [],
  data: () => ({
    proceedings: {},
    occasionalTitle: '',
    occasionals: [],
    modal: false
  }),
  computed: {
    ...mapGetters('auth', ['isStaff']),
    ...mapState('training', ['training', 'subjects']),
    active () {
      const { subject, lectureName } = this.$route.query
      return lectureName || subject
    }
  },
  methods: {
    onViewProceeding (proceeding, subject, lectureName, lectureCode) {
      const active = lectureName || subject
      if (this.active === active) return
      // this.active = active
      let id
      const name = 'StaffProceedingViewPage'
      if (proceeding) {
        id = proceeding._id || 'new'
      } else {
        id = 'new'
      }
      this.$router.push({ name, query: { id, subject, lectureName, lectureCode } })
    },
    // 회의록 로딩
    async load () {
      const training = this.training._id;
      if (training) {
        this.proceedings = await this.$Proceeding.list({ training })
        this.proceedings = this.proceedings.reduce((acc, c) => {
          if (c.subject === '사전평가 분석회의') {
            acc['사전평가 분석회의'] = c
          } else if (c.subject === '비정기 회의록') {
            acc['비정기 회의록'][c.lectureName] = c
          } else {
            if (c.lectureCode) { // NCS
              acc.NCS[c.lectureName] = c
            } else {
              acc.NONNCS[c.subject] = c
            }
          }
          return acc
        }, { '사전평가 분석회의': {}, NCS: {}, NONNCS: {}, '비정기 회의록': {} })
        this.occasionals = Object.keys(this.proceedings['비정기 회의록'])
      }
    },
    isActive (s) {
      return s === this.active ? 'bolder' : 'pointer'
    },
    onAddOccasional () {
      this.occasionalTitle = ''
      this.modal = true
    },
    async onSaveOccasional () {
      let proceeding = this.$Proceeding.create(
        this.training._id, '비정기 회의록', this.occasionalTitle, this.occasionalTitle)
      proceeding = await proceeding.save()
      this.proceedings['비정기 회의록'][this.occasionalTitle] = proceeding
      this.occasionals = Object.keys(this.proceedings['비정기 회의록'])
      this.occasionalTitle = ''
      this.modal = false
    },
    onClose () {
      this.occasionalTitle = ''
      this.modal = false
    }
  },
  created () { this.load() },
  watch: { training: 'load' }
}
</script>
